<ng-template #template>
  <div [class]="remainingCharacterCounter">{{ counter.remainingCharacterCounter }}</div>
</ng-template>